export const CLIENT_LOCATIONS_SORT_OPTIONS = [{ value: "name", label: "Name" }];

export const CLIENT_LOCATIONS_DEFAULT_FILTERS = {
  showDeleted: false,
  sortBy: "name",
  sortDirection: "asc",
};

export function buildClientLocationsFilterChips({
  showDeleted,
  sortBy = "name",
  sortDirection = "asc",
} = {}) {
  const chips = [];
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "locations-show-deleted",
      label: "Show Deleted",
    });
  }
  if (sortBy && sortBy !== "name") {
    chips.push({
      id: "sort",
      key: "sortBy",
      fieldId: "locations-sort-by",
      label: "Sort: Name",
    });
  }
  if (sortDirection && sortDirection !== "asc") {
    chips.push({
      id: "sortDirection",
      key: "sortDirection",
      fieldId: "locations-sort-direction",
      label: `Direction: ${sortDirection === "desc" ? "Descending" : sortDirection}`,
    });
  }
  return chips;
}
